import { render } from "./HeroiconsOutlineAtSymbol.vue?vue&type=template&id=471289c3"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineAtSymbol.vue"]])

export default __exports__